var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": _vm.size,
      "height": _vm.size,
      "viewBox": "0 0 11 13",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.31949 5.30013C7.31949 5.80934 7.11721 6.2977 6.75714 6.65777C6.39707 7.01784 5.90871 7.22013 5.39949 7.22013C4.89028 7.22013 4.40192 7.01784 4.04185 6.65777C3.68178 6.2977 3.47949 5.80934 3.47949 5.30013C3.47949 4.79091 3.68178 4.30255 4.04185 3.94248C4.40192 3.58241 4.89028 3.38013 5.39949 3.38013C5.90871 3.38013 6.39707 3.58241 6.75714 3.94248C7.11721 4.30255 7.31949 4.79091 7.31949 5.30013Z",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.1996 5.3C10.1996 9.87088 5.39961 12.5 5.39961 12.5C5.39961 12.5 0.599609 9.87088 0.599609 5.3C0.599609 4.02696 1.10532 2.80606 2.0055 1.90589C2.90567 1.00571 4.12657 0.5 5.39961 0.5C6.67265 0.5 7.89355 1.00571 8.79372 1.90589C9.6939 2.80606 10.1996 4.02696 10.1996 5.3Z",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }